import { Customer, Organization } from '@leid/api-customers'
import { NextApiRequest } from 'next'
import { ReadonlyRequestCookies } from 'next/dist/server/web/spec-extension/adapters/request-cookies'

import { signOutCustomer } from 'app/serverActions/authentication'
import apiClient from 'helpers/clients/apiClient'
import { getLoggedCustomerInfo } from 'utils/apiUtils/authentication'
import { STORAGE_KEYS } from 'utils/constants'
import { removeFromStorage } from 'utils/storage'

export type CustomerInfo = {
  customer: Customer | null
  organization: Organization | null
}

export const serverGetLoggedCustomerInfo = async (
  cookieStore: ReadonlyRequestCookies,
): Promise<CustomerInfo | undefined> => {
  const req: NextApiRequest = {
    cookies: cookieStore.getAll().reduce((a, v) => ({ ...a, [v.name]: v.value }), {}),
    headers: {
      cookie: cookieStore
        .getAll()
        .map(({ name, value }) => `${name}=${value}`)
        .join('; '),
    },
  } as NextApiRequest

  const customerInfo = await getLoggedCustomerInfo(req)
  return customerInfo
}

export const clientSignOut = async (): Promise<boolean> => {
  // Remove organization cookie if any
  await apiClient.selectOrganizationOrPersonalAccount(undefined)
  // Remove coordinates cookes is any
  await apiClient.setCustomerCoordinates(undefined)

  const result = await signOutCustomer()
  if (!result) {
    return false
  }

  // Remove from local store
  removeFromStorage(STORAGE_KEYS.orderId)
  removeFromStorage(STORAGE_KEYS.orderToken)
  removeFromStorage(STORAGE_KEYS.userToken)
  removeFromStorage(STORAGE_KEYS.shouldRememberCustomer)

  return true
}
